export const imageKeys = {
  all: ['images'] as const,
  upload: () => [...imageKeys.all, 'upload'] as const,
  get: (type: string, id: string) => [...imageKeys.all, 'get', type, id] as const,
}
